// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PasswordForm_info-message__Nv1PV {
  margin: 8px 0 60px;
}

.PasswordForm_reset-button__BRBbU {
  width: 158px;
  min-width: 158px;
}

.PasswordForm_form__9j9uh {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.PasswordForm_response-message__IY2Fe {
  margin-bottom: 20px;
}

.PasswordForm_inputs__ekLKv {
  width: 100%;
  max-width: 448px;
  margin-bottom: 40px;
}

.PasswordForm_input__QrffZ:not(:last-child) {
  margin-bottom: 20px;
}

.PasswordForm_input-error__\\+85r4 {
  margin-top: 4px;
  padding: 0 8px;
  color: #00007a;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
}
.PasswordForm_input-error__\\+85r4 .PasswordForm_input-error-prefix__\\+aPWB {
  margin: 0;
  padding: 0 20px;
}

.PasswordForm_button__FRPY5 {
  width: 200px;
}

@media screen and (max-width: 600px) {
  .PasswordForm_info-message__Nv1PV {
    margin: 0 0 28px;
  }
  .PasswordForm_reset-button__BRBbU {
    width: 100%;
  }
  .PasswordForm_button__FRPY5 {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Contacts/PasswordForm/PasswordForm.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;AAIF;;AADA;EACE,YAAA;EACA,gBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAIF;;AADA;EACE,mBAAA;AAIF;;AADA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;AAIF;;AAAE;EACE,mBAAA;AAGJ;;AACA;EACE,eAAA;EACA,cAAA;EACA,cC9BS;ED+BT,gBAAA;EACA,eAAA;EACA,iBAAA;AAEF;AAAE;EACE,SAAA;EACA,eAAA;AAEJ;;AAEA;EACE,YAAA;AACF;;AAEA;EACE;IACE,gBAAA;EACF;EAEA;IACE,WAAA;EAAF;EAGA;IACE,WAAA;EADF;AACF","sourcesContent":["@use 'styles/colors';\n@use 'styles/sizes';\n\n.info-message {\n  margin: 8px 0 60px;\n}\n\n.reset-button {\n  width: 158px;\n  min-width: 158px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.response-message {\n  margin-bottom: 20px;\n}\n\n.inputs {\n  width: 100%;\n  max-width: 448px;\n  margin-bottom: 40px;\n}\n\n.input {\n  &:not(:last-child) {\n    margin-bottom: 20px;\n  }\n}\n\n.input-error {\n  margin-top: 4px;\n  padding: 0 8px;\n  color: colors.$primary8;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n\n  .input-error-prefix {\n    margin: 0;\n    padding: 0 20px;\n  }\n}\n\n.button {\n  width: 200px;\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .info-message {\n    margin: 0 0 28px;\n  }\n\n  .reset-button {\n    width: 100%;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"info-message": `PasswordForm_info-message__Nv1PV`,
	"reset-button": `PasswordForm_reset-button__BRBbU`,
	"form": `PasswordForm_form__9j9uh`,
	"response-message": `PasswordForm_response-message__IY2Fe`,
	"inputs": `PasswordForm_inputs__ekLKv`,
	"input": `PasswordForm_input__QrffZ`,
	"input-error": `PasswordForm_input-error__+85r4`,
	"input-error-prefix": `PasswordForm_input-error-prefix__+aPWB`,
	"button": `PasswordForm_button__FRPY5`
};
export default ___CSS_LOADER_EXPORT___;
